import React, {useEffect, useRef, useState} from "react";
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {useTranslation} from "react-i18next";
import {createCourier} from "./courier-api";
import CourierProfileForm, {profileValues, validCapacity} from "./courier-profile-form";
import CourierUserPicker from "./courier-user-picker";

export default function CreateCourierDialog({tenantId, onClose, onCreated}) {
    const {t, i18n} = useTranslation();
    const [user, setUser] = useState(null);
    const [values, setValues] = useState(() => profileValues());
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const pending = useRef(false);
    const mounted = useRef(false);
    useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);

    const submit = async event => {
        event.preventDefault();
        if (pending.current || !user || !validCapacity(values.maxActiveOrders)) return;
        pending.current = true; setSaving(true); setError("");
        try {
            const profile = await createCourier({userId: user.id, maxActiveOrders: Number(values.maxActiveOrders),
                active: values.active}, i18n.language);
            if (mounted.current) onCreated(profile);
        } catch (failure) {
            if (mounted.current) setError(failure.response?.data?.message || "CourierProfileSaveFailed");
        } finally {
            pending.current = false;
            if (mounted.current) setSaving(false);
        }
    };

    return <Dialog open fullWidth maxWidth="sm" onClose={() => { if (!pending.current) onClose(); }} disableEscapeKeyDown={saving}>
        <form onSubmit={submit}>
            <DialogTitle>{t("CreateCourierProfile")}</DialogTitle>
            <DialogContent>
                {error && <Alert severity="error" sx={{mb: 2}}>{t(error)}</Alert>}
                <CourierUserPicker value={user} onChange={setUser} tenantId={tenantId} disabled={saving}/>
                <CourierProfileForm values={values} setValues={setValues} disabled={saving}/>
            </DialogContent>
            <DialogActions>
                <Button disabled={saving} onClick={onClose}>{t("Cancel")}</Button>
                <Button type="submit" variant="contained" disabled={saving || !user || !validCapacity(values.maxActiveOrders)}>
                    {t(saving ? "SavingCourierProfile" : "CreateCourierProfile")}</Button>
            </DialogActions>
        </form>
    </Dialog>;
}
